import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type DeletePropertyOwnershipArgs = {
  propertyUid: string;
};

const deletePropertyOwnership = async ({
  propertyUid,
}: DeletePropertyOwnershipArgs) => {
  const response = await API.delete(
    `/api/v3.2/property-ownership/${propertyUid}`,
  );

  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, DeletePropertyOwnershipArgs>,
  'mutationFn'
>;

const useDeletePropertyOwnershipMutation = (
  options?: ReactQueryMutationOptions,
) => {
  return useAppMutation({
    mutationFn: deletePropertyOwnership,
    ...options,
  });
};

export default useDeletePropertyOwnershipMutation;
